import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontWeight, Fonts, Label, Spacing } from "@snapchat/snap-design-system";

export const hostedLensHeaderCss = css`
    display: flex;
    gap: ${Spacing["1XS"]}px;
    align-items: center;

    font-size: ${Fonts.Paragraph.P100};
    font-weight: ${FontWeight.MEDIUM};
    color: ${Colors.Black.V200};
`;

export const bodyContainerCss = css`
    ${Fonts.Paragraph.P200}
    overflow: hidden;
    flex-grow: 1;
`;

export const Anchor = styled.a`
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const GrayLabel = styled(Label)`
    ${Fonts.Paragraph.P300};
    display: flex;
    gap: 5px;
    align-items: center;

    font-weight: ${FontWeight.MEDIUM};
    color: ${Colors.Black.V50};
`;

export const tooltipStatusWrapper = css`
    display: flex;
    flex-direction: column;
    gap: ${Spacing.XS}px;
`;

export const indicatorCSS = css`
    /* needed to override indicators spacing margin, sits too high */
    margin-top: ${Spacing["2XS"]}px !important;
`;
